import { IntlShape } from 'react-intl';
import { MissionWithPrompt } from 'src/api/membot/types';
import {
  Audio,
  CommunicateEventType,
  PageDataLoaded,
  SetConversationCompleted,
  SetConversationStarted,
  SetDisabled,
  SetErrorNotification,
  SetFatalError,
  SetGoalReached,
  SetHintAnimationStatus,
  SetHintLines,
  SetInitialMessagesNumber,
  SetLanguagesInfo,
  SetLoadingHints,
  SetMessage,
  SetMicEnabled,
  SetMicStatus,
  SetMission,
  SetNegativeBotResponseSource,
  SetNegativeBotResponseTarget,
  SetShowResponseHints,
  ToggleHint,
  UndoLastMessage,
  UpdateAudios,
  UpdateDialogList,
} from './types';

export const pageDataLoaded = (): PageDataLoaded => ({
  type: CommunicateEventType.PageDataLoaded,
});

export const updateDialogList = (payload: UpdateDialogList['payload']): UpdateDialogList => ({
  type: CommunicateEventType.UpdateDialogList,
  payload,
});

export const setGoalReached = (payload: SetGoalReached['payload']): SetGoalReached => ({
  type: CommunicateEventType.SetGoalReached,
  payload,
});

export const setDisabled = (payload: SetDisabled['payload']): SetDisabled => ({
  type: CommunicateEventType.SetDisabled,
  payload,
});

export const setMission = (payload: MissionWithPrompt): SetMission => ({
  type: CommunicateEventType.SetMission,
  payload,
});

export const setMessage = (payload: SetMessage['payload'], intl?: IntlShape): SetMessage => ({
  type: CommunicateEventType.SetMessage,
  payload,
  intl,
});

export const setInitialMessagesNumber = (
  payload: SetInitialMessagesNumber['payload'],
): SetInitialMessagesNumber => ({
  type: CommunicateEventType.SetInitialMessagesNumber,
  payload,
});

export const toggleTranslateHint = (): ToggleHint => ({
  type: CommunicateEventType.ToggleTranslateHint,
});

export const setNegativeBotResponseSource = (
  payload: SetNegativeBotResponseSource['payload'],
): SetNegativeBotResponseSource => ({
  type: CommunicateEventType.SetNegativeBotResponseSource,
  payload,
});

export const setNegativeBotResponseTarget = (
  payload: SetNegativeBotResponseTarget['payload'],
): SetNegativeBotResponseTarget => ({
  type: CommunicateEventType.SetNegativeBotResponseTarget,
  payload,
});

export const undoLastMessage = (): UndoLastMessage => ({
  type: CommunicateEventType.UndoLastMessage,
});

export const setShowResponseHints = (
  payload: SetShowResponseHints['payload'],
): SetShowResponseHints => ({
  type: CommunicateEventType.SetShowResponseHints,
  payload,
});

export const setHintAnimationStatus = (
  payload: SetHintAnimationStatus['payload'],
): SetHintAnimationStatus => ({
  type: CommunicateEventType.SetHintAnimationStatus,
  payload,
});

export const setConversationStarted = (
  payload: SetConversationStarted['payload'],
): SetConversationStarted => ({
  type: CommunicateEventType.SetConversationStarted,
  payload,
});

export const setConversationCompleted = (
  payload: SetConversationCompleted['payload'],
): SetConversationCompleted => ({
  type: CommunicateEventType.SetConversationCompleted,
  payload,
});

export const setMicEnabled = (payload: SetMicEnabled['payload']): SetMicEnabled => ({
  type: CommunicateEventType.SetMicEnabled,
  payload,
});

export const setMicStatus = (payload: SetMicStatus['payload']): SetMicStatus => ({
  type: CommunicateEventType.SetMicStatus,
  payload,
});

export const setLoadingHints = (payload: SetLoadingHints['payload']): SetLoadingHints => ({
  type: CommunicateEventType.SetLoadingHints,
  payload,
});

export const setHintLines = (payload: SetHintLines['payload']): SetHintLines => ({
  type: CommunicateEventType.SetHintLines,
  payload,
});

export const setErrorMsg = (payload: SetErrorNotification['payload']): SetErrorNotification => ({
  type: CommunicateEventType.SetErrorNotification,
  payload,
});

export const setFatalError = (payload: SetFatalError['payload']): SetFatalError => ({
  type: CommunicateEventType.SetFatalError,
  payload,
});

export const setLanguagesInfo = (payload: SetLanguagesInfo['payload']): SetLanguagesInfo => ({
  type: CommunicateEventType.SetLanguagesInfo,
  payload,
});

export const updateAudios = (payload: Audio): UpdateAudios => ({
  type: CommunicateEventType.UpdateAudios,
  payload,
});
